'use es6';

import PortalIdParser from 'PortalIdParser';
import apiClient from './SPMRedirectNoAuthApiClient';
import LegalConsentRecord from '../records/LegalConsentRecord';
import PresentationRecord from '../records/PresentationRecord';
import { instrumentPresentationRequest, instrumentConsentRequest } from '../utils/instrumentRequests';
const baseUrl = 'presentations/v1/presentation/public';
const newBaseUrl = 'presentations/v2/public';
const gdprBaseUrl = 'presentations/v1/gdpr/public/presentations';
export const fetchPresentation = (presentationId, accessId) => apiClient.get(`${newBaseUrl}/portals/${PortalIdParser.get()}/presentations/${presentationId}/${accessId}`, {
  query: {
    portalId: PortalIdParser.get()
  }
}).then(presentation => {
  instrumentPresentationRequest();
  return PresentationRecord.create(presentation);
});
export const fetchPresentationPdfUrl = (presentationId, accessId) => apiClient.get(`${baseUrl}/${presentationId}/pdfDownloadUrl`, {
  query: {
    portalId: PortalIdParser.get(),
    accessId
  }
});
export const fetchPresentationDownloadUrl = (presentationId, accessId) => apiClient.get(`${newBaseUrl}/portals/${PortalIdParser.get()}/presentations/${presentationId}/${accessId}/downloadUrl`);
export const fetchMeetingLink = userId => apiClient.get('meetings-public/v1/link/default', {
  query: {
    portalId: PortalIdParser.get(),
    userId
  }
});
export const fetchLegalConsent = (presentationId, accessId) => apiClient.get(`${gdprBaseUrl}/${presentationId}/viewer-form`, {
  query: {
    portalId: PortalIdParser.get(),
    accessId
  }
}).then(res => {
  instrumentConsentRequest();
  return LegalConsentRecord.fromJS(res);
});
export const postLegalConsentFeedback = ({
  presentationId,
  accessId,
  formGuid,
  email,
  deckLegalConsentEnabled,
  consentReceived,
  communicationTypeId,
  legalConsentOptions
}) => apiClient.post(`${gdprBaseUrl}/viewer-form`, {
  data: {
    portalId: PortalIdParser.get(),
    presentationId,
    accessId,
    formGuid,
    email,
    deckLegalConsentEnabled,
    consentReceived,
    communicationTypeId,
    legalConsentOptions
  }
});